let Page   = require('../mixins/base-page');
let Search = require('../mixins/base-search');

module.exports = {
 	mixins: [Page, Search],

 	methods: {
 		search() {
 			// use grid to search
 		},

 		articlesLoading() {
 			this.searching = true;
 		},

 		articlesLoaded(items, pagination) {
 			this.loadingSearch = false;
			this.searching     = false;
			this.searchResults = items;
			this.pagination    = pagination;
 		}
 	}
};
